// Routes owned by the ReleaseNotes module. Merged into the app-wide `paths` object
// by src/app/paths.ts; see src/modules/README.md.
export const releaseNotesPaths = {
    releaseNotes: '/release-notes',
} as const
